<script lang="ts" setup>
import { computed } from "vue";

const props = defineProps<{
  value?: number;
  size?: string;
  type?: "single" | "double";
  negative?: number;
  positive?: number;
}>();

const stylesLeft = computed(() => {
  const style: Record<string, any> = {};

  if (props.size === "large") {
    style["height"] = "24px";
  }

  if (props.type !== "double") {
    if (props.value < 0) {
      style["background"] =
        `linear-gradient(270deg, #e66e79 0%, #e66e79 ${Math.abs(props.value)}%, rgba(0, 0, 0, 0) ${Math.abs(props.value)}%)`;
    }
  }

  if (props.type === "double") {
    style["background"] =
      `linear-gradient(270deg, #e66e79 0%, #e66e79 ${Math.abs(props.negative)}%, rgba(0, 0, 0, 0) ${Math.abs(props.negative)}%)`;
  }
  return style;
});

const stylesRight = computed(() => {
  const style: Record<string, any> = {};

  if (props.size === "large") {
    style["height"] = "24px";
  }

  if (props.type !== "double") {
    if (props.value > 0) {
      style["background"] =
        `linear-gradient(90deg, #2cbfaf 0%, #2cbfaf ${props.value}%, rgba(0, 0, 0, 0) ${props.value}%)`;
    }
  }
  if (props.type === "double") {
    style["background"] =
      `linear-gradient(90deg, #2cbfaf 0%, #2cbfaf ${props.positive}%, rgba(0, 0, 0, 0) ${props.positive}%)`;
  }
  return style;
});
</script>

<template>
  <div class="vi-rating-bar">
    <div :style="stylesLeft" class="vi-rating-bar__left" />
    <div :style="stylesRight" class="vi-rating-bar__right" />
  </div>
</template>

<style scoped lang="scss">
.vi-rating-bar {
  width: 100%;
  background-color: #f0f1f5;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: center;
  border: 0.5px solid #dcdde2;

  &__left,
  &__right {
    width: 50%;
    height: 12px;
  }

  &__left {
    align-self: left;
  }

  &__right {
    align-self: right;
  }
}
</style>
